<template>
  <div>
    <header class="pt10">
      <DateChange ref="dateChange" @change="handlerDateChange">
        <template #title>
          <van-cell @click="storeSelectVisible = true">
            <van-field
              autocomplete="off"
              v-model="params.storeName"
              name="storeName"
              inputmode="none"
              placeholder="请选择仓库"
              readonly
            />
          </van-cell>
        </template>
      </DateChange>
      <StoreSelect
        :visible="storeSelectVisible"
        @confirm="storeSelectConfirm"
      ></StoreSelect>
    </header>

    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已显示全部"
      ref="scrollContainer"
      @load="getList(true)"
    >
      <div v-for="item in tableData" :key="item.id" class="container">
        <!-- 头部：单据号 + 状态 -->
        <div class="header">
          <div class="header-left">
            <div class="code">单据号: {{ item.code }}</div>
            <div class="code">关联盘点任务: {{ item.planCode }}</div>
            <div class="code">操作时间: {{ item.updateTime }}</div>
            <div class="code">审核时间: {{ item.approveTime }}</div>
            <div class="code">备注: {{ item.description }}</div>
          </div>
          <div class="header-right">
            <div class="tit">
              {{ getTextByValue(TAKE_STOCK_PLAN_TYPE, item.takeType) }}
            </div>
            <div class="store-name">{{ item.scName }}</div>
            <van-tag :type="getStatusType(item.status)" size="small">
              {{ getStatusDesc(item.status) }}
            </van-tag>
            <van-tag
              :type="getTakeStatusType(item.takeStatus)"
              plain
              size="small"
              class="take-status-tag"
            >
              {{ getTakeStatusDesc(item.takeStatus) }}
            </van-tag>
          </div>
        </div>
        <!-- 操作按钮 -->
        <div class="actions">
          <div class="action-item" @click="handleDetail(item)">查看</div>
          <div
            v-if="canShowModify(item)"
            class="action-item"
            @click="handleModify(item)"
          >
            去盘点
          </div>
          <div
            v-if="canShowCancelApprove(item)"
            class="action-item"
            @click="handleCancelApprove(item.id)"
          >
            取消审核
          </div>
          <div
            v-if="canShowDelete(item)"
            class="action-item"
            @click="deleteRow(item.id)"
          >
            删除
          </div>
        </div>
      </div>
    </van-list>

    <div class="action-btn">
      <van-button type="primary" round block @click="toAddInventory">
        新增盘点单
      </van-button>
    </div>
  </div>
</template>

<script>
import DateChange from "../../../components/dateChange.vue";
import StoreSelect from "../../../components/storeSelect.vue";
import {
  query,
  cancelApprovePass,
  deleteById,
} from "../../../service/api/stock/take/index";
import { getTextByValue } from "../../../utils/constants";
import {
  TAKE_STOCK_SHEET_STATUS,
  TAKE_STOCK_PLAN_STATUS,
  TAKE_STOCK_PLAN_TYPE,
} from "../../../utils/constants";

export default {
  name: "InventoryList",
  components: {
    DateChange,
    StoreSelect,
  },
  data() {
    return {
      name: "盘点单",
      TAKE_STOCK_PLAN_TYPE,
      getTextByValue,
      params: {
        searchStr: "",
        scId: null,
        storeName: "",
        updateTimeStart: `${new Date().toJSON().slice(0, 10)} 00:00:00`,
        updateTimeEnd: `${new Date().toJSON().slice(0, 10)} 23:59:59`,
        pageIndex: 1,
        pageSize: 20,
      },
      storeSelectVisible: false,
      loading: false,
      finished: false,
      tableData: [],
      totalCount: 0,
      pageIndex: 1,
      pageSize: 20,
      totalPage: 1,
      columns: [
        {
          key: "code",
          title: "单据号",
        },
        {
          key: "planCode",
          title: "关联盘点任务",
        },
        {
          key: "takeStatus",
          title: "盘点状态",
          formatter: (cellValue) => {
            return getTextByValue(TAKE_STOCK_PLAN_STATUS, cellValue);
          },
        },
        {
          key: "takeType",
          title: "盘点类别",
          formatter: (cellValue) => {
            return getTextByValue(TAKE_STOCK_PLAN_TYPE, cellValue);
          },
        },
        {
          key: "status",
          title: "状态",
          formatter: (cellValue) => {
            return getTextByValue(TAKE_STOCK_SHEET_STATUS, cellValue);
          },
        },
        {
          key: "updateTime",
          title: "操作时间",
        },
        {
          key: "approveTime",
          title: "审核时间",
        },
        {
          key: "description",
          title: "备注",
        },
      ],
    };
  },
  mounted() {
    this.params.updateTimeStart = this.$refs.dateChange.formattedStartDate
      ? this.$refs.dateChange.formattedStartDate + " 00:00:00"
      : `${new Date().toJSON().slice(0, 10)} 00:00:00`;
    this.params.updateTimeEnd = this.$refs.dateChange.formattedEndDate
      ? this.$refs.dateChange.formattedEndDate + " 23:59:59"
      : `${new Date().toJSON().slice(0, 10)} 23:59:59`;
    // 清除所有inventory_plan_开头的localStorage数据
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith("inventory_plan_")) {
        localStorage.removeItem(key);
      }
    }
    this.onSubmit();
  },
  methods: {
    getTakeStatusDesc(cellValue) {
      return getTextByValue(TAKE_STOCK_PLAN_STATUS, cellValue);
    },
    getStatusDesc(cellValue) {
      return getTextByValue(TAKE_STOCK_SHEET_STATUS, cellValue);
    },

    getTypeTag(type) {
      const typeMap = {
        0: "primary",
        1: "success",
        2: "warning",
        3: "danger",
      };
      return typeMap[type] || "default";
    },

    getFormatter(key) {
      const column = this.columns.find((el) => el.key === key);
      return column ? column.formatter : null;
    },

    getStatusType(status) {
      const typeMap = {
        0: "warning",
        3: "success",
        6: "danger",
      };
      return typeMap[status] || "default";
    },

    getTakeStatusType(status) {
      const typeMap = {
        0: "primary",
        6: "warning",
        9: "success",
        12: "danger",
      };
      return typeMap[status] || "default";
    },
    canShowModify(row) {
      return (row.status === 0 || row.status === 6) && row.takeStatus === 0;
    },
    canShowCancelApprove(row) {
      return row.status === 3 && row.takeStatus === 0;
    },
    canShowDelete(row) {
      return row.status === 0 || row.status === 6;
    },
    search() {
      this.onSubmit();
    },
    handlerDateChange(start, end) {
      this.params.updateTimeStart = start ? `${start} 00:00:00` : start;
      this.params.updateTimeEnd = end ? `${end} 23:59:59` : end;
      this.onSubmit();
    },
    storeSelectConfirm(row) {
      this.params.scId = row.id;
      this.params.storeName = row.name;
      console.log(row, row.id, row.name, "params---", this.params);
      this.storeSelectVisible = false;
      this.onSubmit();
    },
    onSubmit() {
      this.pageIndex = 1;
      this.finished = false;
      this.tableData = [];
      this.loading = false;
      this.getList();
    },
    getList(load) {
      if (load) {
        this.pageIndex++;
      }
      this.loading = true;
      const params = {
        ...this.params,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      query(params)
        .then((res) => {
          this.loading = false;
          console.log(res, "列表结果");
          if (res.code === 200) {
            const list = res.data.datas || [];
            this.totalCount = res.data.totalCount || 0;
            this.totalPage = Math.ceil(this.totalCount / this.pageSize);
            if (this.pageIndex === 1) {
              this.tableData = list;
            } else {
              this.tableData = [...this.tableData, ...list];
            }
            this.finished =
              this.pageIndex >= this.totalPage || list.length === 0;
          } else {
            this.finished = true;
          }
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
        });
    },
    toAddInventory() {
      this.$router.push("/stock/inventory/task");
    },
    handleDetail(row) {
      this.$router.push({
        path: "/stock/inventory/goods",
        query: {
          sheetId: row.id,
          planId: row.planId || "",
          type: "detail",
        },
      });
    },
    handleModify(row) {
      this.$router.push({
        path: "/stock/inventory/goods",
        query: {
          sheetId: row.id,
          planId: row.planId || "",
          type: "edit",
        },
      });
    },
    handleApprove(row) {
      this.$router.push("/stock/take/sheet/approve/" + row.id);
    },
    handleCancelApprove(id) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定要取消审核吗？",
        })
        .then(() => {
          cancelApprovePass(id).then((res) => {
            if (res.code === 200) {
              this.onSubmit();
            }
          });
        })
        .catch(() => {});
    },
    deleteRow(id) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定要删除吗？",
        })
        .then(() => {
          deleteById(id).then((res) => {
            if (res.code === 200) {
              this.onSubmit();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
* {
  touch-action: pan-y;
}
.van-cell {
  padding: 5px 2px 2px 5px !important;
}

.container {
  .tit {
    color: #000;
  }

  padding: 10px 15px;
  border-radius: 4px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
  }

  .header-left {
    .title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 4px;
    }

    .code {
      font-size: 14px;
      color: #333;
    }
  }

  .header-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;

    .store-name {
      font-size: 14px;
      color: #666;
      font-weight: 500;
    }

    .van-tag {
      padding: 0.3rem;
    }

    .take-status-tag {
      margin-top: 2px;
    }
  }

  .info-row {
    display: flex;
    margin-bottom: 8px;
    gap: 20px;
  }

  .info-item {
    flex: 1;
    display: flex;
    line-height: 24px;
    font-size: 14px;

    &.full {
      flex: 1 1 100%;
    }

    .label {
      color: #999;
      min-width: 70px;
    }

    .value {
      flex: 1;
      color: #333;
    }
  }

  .actions {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .action-item {
      flex: 1;
      text-align: center;
      cursor: pointer;
      color: #333;
      font-size: 14px;
      padding: 4px 0;
      position: relative;

      &:hover {
        color: #409eff;
      }

      &:not(:last-child):after {
        content: "";
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 1px;
        height: 14px;
        background-color: #eee;
      }
    }
  }
}

::v-deep .van-list {
  height: calc(100vh - 12.5rem);
  overflow: auto;
}

.action-btn {
  width: 80%;
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
